import React, { Component, cloneElement } from 'react'
import PropTypes from 'prop-types'

import Container from './StickyBar.styles'

class StickyBar extends Component {
  render() {
    const { children, inView } = this.props
    const itemList = Array.isArray(children) ? children : [children]
    const listCopy = itemList.map((item, key) => cloneElement(item, { key }))

    return (
      <Container inView={inView} tabIndex='-1' aria-hidden data-test='sticky-bar'>
        {inView ? null : listCopy}
      </Container>
    )
  }
}

StickyBar.propTypes = {
  children: PropTypes.array.isRequired
}

export default StickyBar
